import { LinkGroup } from "./LinkGroup";

export default LinkGroup;
